// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__Lxv4X","exiting":"Dialog_exiting__ZrUF0","entering":"Dialog_entering__9IEDC","enter":"Dialog_enter__anYWb","exit":"Dialog_exit__YdBbe"};